<script>
/* jshint esversion: 6 */
import { computed, watch, inject } from 'vue';
import './../func.common.js';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'FileUploadHint',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
		'hinted': {type:String},
        'disabled': {type: Boolean},
        'fileHint': {type: String},
        'formBox': { type: [Object], default: function() { return {};} }, 
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    emits: ['validateChild'], 
    setup(props) {

        const validateChild = inject('validateChild');
        let isDragging = false;
        let checkArray = {
            idLabel: `fileToUpload${props.schema.model}`,
            tdPreview: `td${props.schema.model}`,
            fileUpload: props.schema.fileUpload,
            dragDrop: `drag${props.schema.model}`,
            toParent: {
                'id' : props.schemaId,
                'model': props.schema.model,
                'validator' : props.schema.validator,
            }
        };

        
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            if (validateChild) {
                validateChild(checkArray.toParent);
            }
        }, {deep: true});


        function trashIt(value) {
            var fileSplit = value.split('_');
            if (fileSplit[fileSplit.length - 1] === 'WEB.pdf') {
                props.model.docFileName = '';
            }
            //find index of object for delete
            var indexOfDelete = props.model[checkArray.fileUpload]
                .map((e) => e.name)
                .indexOf(value);

            var indexOfDelete2 = props.model[props.schema.model]
                .map((e) => e)
                .indexOf(value);

            props.model[checkArray.fileUpload].splice(
                indexOfDelete,
                1
            );

            props.model[props.schema.model].splice(
                indexOfDelete2,
                1
            );

            if (validateChild) {
                validateChild(checkArray.toParent);
            }
        }

        function removeDuplicates(originalArray, prop) {
            var newArray = [];
            var lookupObject = {};

            originalArray.forEach((value) => {
                lookupObject[value[prop]] = value;
            });

            Object.entries(lookupObject).forEach((value) => {
                newArray.push(value[1]);
            });

            return newArray;
        }


        function dragover(e) { 
            e.preventDefault();
            isDragging = true; 
        }

        function dragleave(e) {
            e.preventDefault();
            isDragging = false;
        }

        function onDrop(e) {
            e.preventDefault();
            isDragging = false;
            fileChange(e);
        }
        
        function fileChange(e) {
            //empty model.files
            props.model[props.schema.model] = [];

            //file Variable
            var files = e.target.files || e.dataTransfer.files; 

            //upload files in Model
            Object.entries(files).forEach((value) => {
                props.model[props.schema.fileUpload].push(value[1]);
            });

            //remove Duplicates
            props.model[props.schema.fileUpload] = removeDuplicates(
                props.model[props.schema.fileUpload],
                'name'
            );

            //empty model
            props.model[props.schema.model] = [];

            var that = this;
            props.model[props.schema.fileUpload].forEach((value) => {
                props.model[props.schema.model].push(value.name);
            });

            if (props.schema.typeChange && props.schema.typeChange === true) { typeChange(); }
            if (props.schema.imageChange && props.schema.imageChange === true) { imageChange(); }
        }
        
        function typeChange() {
            //reset model files
            props.model.fileTypeGeneral.forEach(element => props.model[element] = 0);
            props.model[props.schema.model].forEach(element => {
            var fileSplit = element.split("_");
            var typeSplit = fileSplit[fileSplit.length-1].split(".");
                props.model[typeSplit[0].toLowerCase()] = 1;
            });

            //printType change
            let printTypeIndex = props.fullSchema.fields.findIndex(element => element.model === 'printType');
            let printTypeArr = props.fullSchema.fields[printTypeIndex];
            let fromChild = {
                'id' : printTypeIndex,
                'model': printTypeArr.model,
                'validator' : printTypeArr.validator,
            }
            if (validateChild) {
                validateChild(fromChild);
            }
        }

        function imageChange() {
            if (validateChild) {
                validateChild(checkArray.toParent);
            }
        }
        
        return {
            isDragging,
            checkArray,
            helperName,
            trashIt,
            removeDuplicates,
            dragover,
            dragleave,
            onDrop,
            fileChange,
            // typeChange
        };
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fileUploadHint(
        :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        .form-group.fieldFileUpload
            label {{ schema.label }} 
            .field-wrap
                .fileBox( :style="disabled === true ? 'cursor:not-allowed; opacity: 0.5': ''")
                    .uploadBox
                        #uploadDropZone(
                            @drop="onDrop"
                            @dragover="dragover"
                            @dragleave="dragleave"
                            :style="disabled === true ? 'pointer-events:none': ''"
                        )
                            input(
                                name="filesToUpload[]"
                                :id="checkArray.idLabel"
                                type="file" 
                                multiple="multiple" 
                                @change="fileChange"
                                :style="disabled === true ? 'pointer-events:none': ''"
                            )
                            label(:for="checkArray.idLabel" class="file-label" :style="disabled === true ? 'pointer-events:none': ''")
                                div.uploadBackgroundIcon 
                                    div.iconWidth
                                        font-awesome-icon(icon="fa-solid fa-arrow-up-from-bracket")
                                        div Drop files here or click to upload
                        br
                        template(v-if="model[schema.model].length > 0")
                            .previewDiv
                                .previewBox(:id="checkArray.tdPreview")
                                    ul
                                        li(v-for="(value, id) in model[schema.model]")
                                            .previewFlex
                                                .previewTitle {{ value }}
                                                .previewTrash(@click="trashIt(value)" :style="disabled === true ? 'pointer-events:none': ''")
                                                    font-awesome-icon(icon="fa-regular fa-trash-can")
                        .hintBox 
                            .boldFont Hinweis:
                            div(v-html="schema.fileHint")
            .row.fieldInput.col-12
                .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
            template(v-if="schema.errorShow === true")
                br
                .vueFormSmall.labelred(v-if="schema.errorShow === true")
                    font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                    | &nbsp; Fehler in der/den Datei/en
                    ul
                        template(v-for="item in schema.errorText")
                            li(v-html="item")
</template>